/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description toCityUrl
 */

import { hyphenate } from '@zcode/utils'

import { APTS_BASE_URL } from '../../../settings'

interface Params {
  city?: string | null
  state?: string | null
  cityState?: string | null
  basePath?: `${'apartments' | 'condos' | 'houses' | 'rooms'}-for-rent`
}

/**
 * create absolute city url
 * will produce: /:basePath/:city-:state or /:basePath/:cityState
 * e.g. /apartments-for-rent/san-francisco-ca
 *
 */

export const toCityUrl = ({ city, state, cityState, basePath = APTS_BASE_URL }: Params) => {
  if (cityState) {
    return `/${basePath}/${cityState}` as const
  } else if (city && state) {
    return `/${basePath}/${hyphenate(city, state)}` as const
  } else {
    return null
  }
}
